import Phaser from "phaser"
import { cGame } from "../cGame";
import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { ModuleCollection,Base } from "../cGameObjects/modules";
import { cSpriteLoad } from "../cGameObjects/cSpriteLoad";

export class stickerPoster extends Phaser.GameObjects.Container {

  public modules: ModuleCollection;
  private _data: ScreenItem
  public events!: Phaser.Events.EventEmitter

  private _sc:cScene;
  public isContainer:boolean = true
  private bg!:cSpriteLoad
  private shapeMask!: any
  private shapeList!:any[]
  private buttonList!:any[]
  private isInteractive!: boolean;

  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0);
    this._data = data;
    this._sc = sc;
    this.modules = Base.initModules(this,data)  
    this.init();
  }

  init(){
    this.shapeList = []
    this.buttonList = []

    //var curst = cGame.current.state.get('2::wahl_game_state','-');
    var curst = cGame.current.state.get('2::posterMode','-');
    var visibleStates = ['poster','hang']
    var data = this._data;


    if (visibleStates.indexOf(curst) === -1 && !this._sc.debugMode) {
      this.visible = false
      this.isInteractive = false;
      return
    }else{
      this.visible = true
      this.isInteractive = curst !== 'hang'
      console.log('IS AVITB', curst)
    }
    
    console.log('IS INTERACTIVE',this.isInteractive)
    if (this.bg){ 
      this.removeAll(true); 
    }

    //user the spriteLoader to load the png from the assets list baesded on the
    //statename
    var stateName  = data.statemodule+'::'+data.statename as string
    var stateValue = cGame.current.state.get(stateName ,null)
    if (stateValue === null) console.error('State Empty',stateName)
    var assetName = data.asset + String(stateValue).toLowerCase()

    this.bg = new cSpriteLoad(this._sc,{
      type:'',
      id:'',
      name:'',
      origin:'0x0',
      ofs:'0x0'
    });
    this.add(this.bg)
    this.bg.asset = this.getAssetFilename(assetName, stateValue)
  
    //create the background mask as shape
    this.shapeMask = this._sc.make.graphics({x:0,y:0,fillStyle: {
          color: 0xff00ff,
          alpha: 0.5
       }
    },false)
    this.shapeMask.visible = this._sc.debugMode
    this.add(this.shapeMask)
    this.addToMask(null,-1)

    //admin workaround
    if(!this.modules.data._extraData && data.objectdata){
      this.modules.data._extraData = JSON.parse(data.objectdata)
    }
    this.initShapes()
  }

  getAssetFilename(assetName:string, value:string){
    var v = (this.scene as cScene).sceneData.assets.reduce( (pay,val)=>(val.name===assetName) ? val.url : pay,'' );
    if (this._data.frame){
      v = v.replace(this._data.frame,value)
    }
    return v
  }


  initShapes(){
    //append all the rectangles
    console.log('append shapes',this.isInteractive)
    if (this.modules.data._extraData){

      this.buttonList = this.modules.data._extraData.map( (cordScript:string,i:number)=>{                
        var cords = cordScript.split('x');
        var limit = null;
        if (cords.length === 5){
          limit = cords.pop() as string;
        }
        return this.appendShape(cords ,i, limit )
      })
    }

    //apply the current state of the posters

    cGame.current.state.get('2::posters',[]).filter( (el:any)=>String(el).indexOf(this._data.name)===0  ).forEach( (nm:string)=>{
      var idx = Number(nm.split('_').pop())
      if (!isNaN(idx)){        
        var r:any = (this.buttonList[idx] as Phaser.GameObjects.Rectangle);
        if (r){
          r.visible = false
          this.addToMask( r.tmpdata, -1 )
        }
      }
    })
  }


  appendShape(rectData:any,idx:number, limitToParty:string | null){
    rectData = rectData.map((v:string)=>Number(v))    
    var btnShape = this.scene.add.rectangle( rectData[0],rectData[1],rectData[2],rectData[3],0xff0000, (this.scene as cScene).debugMode ? 0.6 : 0 )
    btnShape.setOrigin(0,0)
    if (this.isInteractive) btnShape.setInteractive();
    (btnShape as any).tmpdata = rectData

    var stateName  = this._data.statemodule+'::'+this._data.statename as string

    btnShape.on('pointerup',()=>{
      var curParty = cGame.current.state.get(stateName ,null);
      console.log(limitToParty, curParty);
      if (limitToParty && limitToParty !== curParty){
        this._sc.triggerSceneEvent('wrong-party')
        return
      }

      this.addToMask(rectData,idx)
      btnShape.visible = false
    });
    this.add(btnShape)
    return btnShape
  }

  addToMask(shapeData:any, idx:number){
    if (shapeData) this.shapeList.push(shapeData);

    this.shapeMask.clear()
    this.shapeList.forEach( (c)=>this.shapeMask.fillRect(c[0],c[1],c[2],c[3]) )
    var mask = this.shapeMask.createGeometryMask();    
    if (!(this.scene as cScene).debugMode){
      this.bg.mask = mask;
    }

    if(idx !== -1 ){
      var p = cGame.current.state.get('2::posters',[])
      p.push(this._data.name+idx)
      cGame.current.state.set('2::posters',p)
    }
  }

  appendBackground(){
    //this.bg = new Phaser.GameObjects.Sprite(sc,)
  }

  public set debugState(v:string){
    if (!(this.scene as cScene).debugMode) return
    setTimeout( ()=>{
      var assetName = this.modules.data.data.asset + v
      console.log('POSTER DEBUG', assetName)
      this.bg.asset = this.getAssetFilename(assetName, v)
      this.bg.alpha = 0.5
    },50)    
  }


  public set reset(v:string){
    if (this.shapeMask) this.shapeMask.clear()
    //this.buttonList.forEach( (e)=>this.scene.scene.remove(e) )
  }

  public set refresh(v:string){
    this.init();
  }

}